<div class="ofi-flex">
  <button
    ejs-button
    *ngFor="let btn of buttons"
    [value]="btn.value"
    [class]="btn.cssClass"
    [cssClass]="btn.cssClass"
    (click)="onClick(btn)"
  >
    {{ btn.name }}
  </button>
</div>
